<template>
	<div>
		<apexchart 
			type="bar" 
			height="450" 
			:options="chartOptions" 
			:series="series"
		></apexchart>
	</div>
</template>

<script>
import VueApexCharts from 'vue-apexcharts';

export default {
  name: 's-column-chart',
  components: {
    apexchart: VueApexCharts,
  },
  props: {
    title: {
      type: String,
      required: true,
    },
    seriesName: {
      type: String,
    },
    xAxisData: {
      type: Array,
      required: true,
    },
    yAxisData: {
      type: Array,
      required: true,
    },
    showAverage: {
      type: Boolean,
      default: false,
    },
    xAxisAverageOntimeefficiency: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    series() {
      return [{
        name: this.seriesName,
        data: this.yAxisData
      }];
    },
    chartOptions() {
      const seriesName = this.seriesName;
      return {
        chart: {
          height: 350,
          type: 'bar',
        },
        plotOptions: {
          bar: {
            borderRadius: 10,
            dataLabels: {
              position: 'top', // top, center, bottom
            },
          }
        },
        dataLabels: {
          enabled: true,
          formatter: (val, opts) => {
            if (this.showAverage) {
              return this.xAxisAverageOntimeefficiency[opts.globals.labels[opts.dataPointIndex]] + "%";
            } else {
              return val;
            }
          },
          offsetY: -20,
          style: {
            fontSize: '12px',
            colors: ["#304758"]
          }
        },
        xaxis: {
          categories: this.xAxisData,
          position: 'top',
          labels: {
            offsetY: -10,
            style: {
              fontSize: '12px',
              fontWeight: 400
            }
          },
          axisBorder: {
            show: false
          },
          axisTicks: {
            show: false
          },
          crosshairs: {
            fill: {
              type: 'gradient',
              gradient: {
                colorFrom: '#D8E3F0',
                colorTo: '#BED1E6',
                stops: [0, 100],
                opacityFrom: 0.4,
                opacityTo: 0.5,
              }
            }
          },
          tooltip: {
            enabled: true,
          }
        },
        yaxis: {
          axisBorder: {
            show: false
          },
          axisTicks: {
            show: false,
          },
          labels: {
            show: false,
            formatter: function (val) {
              if (seriesName === 'On-time Efficiency') {
                return val + "%";
              } else {
                return val;
              }
            }
          }
        },
        title: {
          text: this.title,
          floating: true,
          offsetY: 430,
          align: 'center',
          style: {
            color: '#444'
          }
        }
      };
    }
  }
}
</script>